import {
  Dashboard,
  Clientes,
  Master,
  Paquetes,
  Detalle,
  Estados,
  Entrega,
  Boletines,
  Sucursal,
  ConfigSucursal,
  Configuracion,
  Licencia,
  Reportes,
  Traspaso,
  Contrasena,
  Anexos,
  //Productos,
  DespachoApp,
  FacturacionView,
  BoletaListado,
  ProductosView,
  AccessDenied,
  AccessMatenain,
  TiposSalidasView,
} from '../views/views.general';

import * as Admin from '../views/administration/views/view.general';

const routes = {
  'master': [
    { path: '/dashboard', exact: false, name: 'dashboard' , component: Admin.Dashboard },
  ],
  'admin': [
    { path: '/dashboard', exact: false, name: 'dashboard' , component: Dashboard },
    { path: '/clientes', exact: false, name: 'clientes' , component: Clientes },
    { path: '/master', exact: false, name: 'master' , component: Master },
    { path: '/paquetes', exact: false, name: 'paquetes', component: Paquetes},
    { path: '/detalle/:uuid', exact: false, name: 'detalle', component: Detalle},
    { path: '/estados', exact: false, name: 'estado', component: Estados},
    { path: '/entrega', exact: false, name: 'entregas', component: Entrega},
    { path: '/boletines', exact: false, name: 'boletines', component: Boletines},
    { path: '/sucursal', exact: true, name: 'sucursal', component: Sucursal},
    { path: '/sucursal/:uuid', exact: true, name: 'sucursal configuracion', component: ConfigSucursal},
    { path: '/configuracion', exact: true, name: 'Configuracion', component: Configuracion},
    { path: '/licencia', exact: true, name: 'Licencia', component: Licencia},
    { path: '/reportes', exact: true, name: 'Reportes', component: Reportes},
    { path: '/traspaso', exact: true, name: 'Traspaso', component: Traspaso},
    { path: '/anexos', exact: true, name: 'Anexos', component: Anexos},
    { path: '/ventas', exact: true, name: 'Ventas', component: FacturacionView},
    { path: '/ventas/ajuste/:uuid', exact: true, name: 'Ventas', component: FacturacionView},
    { path: '/despacho/app', exact: true, name: 'Despacho app', component: DespachoApp},
    { path: '/boletas/listado/', exact: true, name: 'Listado de Boletas', component: BoletaListado},
    { path: '/boletas/listado/:boletaId', exact: true, name: 'Listado de Boletas', component: BoletaListado },
    { path: '/ventas/productos', exact: true, name: 'Productos', component:  ProductosView },
    { path: '/access-denied', exact: true, name: 'Accesso Denegado', component:  AccessDenied },
    { path: '/access-matenain', exact: true, name: 'En mantenimiento', component:  AccessMatenain },
    { path: '/tipos-salidas', exact: true, name: 'Tipos de salidas', component: TiposSalidasView }
  ],
  'gestor': [
    { path: '/dashboard', exact: false, name: 'dashboard' , component: Dashboard },
    { path: '/clientes', exact: false, name: 'clientes' , component: Clientes },
    { path: '/paquetes', exact: false, name: 'paquetes', component: Paquetes},
    { path: '/detalle/:uuid', exact: false, name: 'detalle', component: Detalle},
    { path: '/entrega', exact: false, name: 'entregas', component: Entrega},
    { path: '/contrasena', exact: false, name: 'Cambio de contrasena', component: Contrasena},
    { path: '/ventas', exact: true, name: 'Ventas', component: FacturacionView},
    { path: '/ventas/ajuste/:uuid', exact: true, name: 'Ventas', component: FacturacionView},
    { path: '/boletas/listado/', exact: true, name: 'Listado de Boletas', component: BoletaListado},
    { path: '/boletas/listado/:boletaId', exact: true, name: 'Listado de Boletas', component: BoletaListado },
    { path: '/access-denied', exact: true, name: 'Accesso Denegado', component:  AccessDenied },
    { path: '/access-matenain', exact: true, name: 'En mantenimiento', component:  AccessMatenain }
  ]
};

export {
  routes
};